<template>
  <div class="ui container">
    <div class="ui left aligned">
      <div class="ui form">
        <div class="inline fields">
          <div class="field">
            <label>剧集</label>
            <select v-model="starId" @change="load()">
              <option value=""></option>
              <option :value="item" v-for="item of names">{{ item }}</option>
            </select>
          </div>
          <div class="inline fields">
            <label>榜单</label>
            <div class="field">
              <div class="ui radio checkbox">
                <input type="radio" name="type" value="0" v-model="type" @change="loadAll()">
                <label>总榜</label>
              </div>
            </div>
            <div class="field">
              <div class="ui radio checkbox">
                <input type="radio" name="type" value="2" v-model="type" @change="loadAll()">
                <label>电视剧</label>
              </div>
            </div>
          </div>
          <button @click="refresh()" class="ui primary mini button" id="refresh"><i class="sync icon"></i></button>
        </div>
      </div>

      <vuetable ref="vuetable"
                :api-url="'/episode-hot?name=' + starId"
                :fields="fields"
                :sort-order="sortOrder"
                :perPage="15"
                @vuetable:pagination-data="onPaginationData"
      >
      </vuetable>
      <div class="ui grid">
        <div class="ui left aligned six wide column">
          <vuetable-pagination-info ref="paginationInfo"></vuetable-pagination-info>
        </div>
        <div class="right floated six wide column">
          <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
        </div>
      </div>
    </div>
    <div class="ui hidden divider"></div>
    <v-chart id="chart" :options="options" theme="light"></v-chart>
  </div>
</template>
<style scoped>
  .form {
    padding-top: 15px;
  }

  #refresh {
    margin-left: 24px;
  }
  @media screen and (min-width:960px) {
    #chart {
      width: 900px;
      height: 400px;
    }
  }
</style>
<script>
  import Vuetable from '../table/Vuetable.vue'
  import VuetablePagination from '../table/VuetablePagination.vue'
  import VuetablePaginationInfo from '../table/VuetablePaginationInfo.vue'
  import axios from 'axios'
  import ECharts from 'vue-echarts'

  export default {
    name: 'News',
    components: {
      Vuetable,
      VuetablePagination,
      VuetablePaginationInfo,
      'v-chart': ECharts
    },
    data () {
      return {
        type: 0,
        page: 0,
        starId: "",
        names: [],
        fields: [
          {name: 'name', title: '姓名'},
          {name: 'searchRank', title: '排名'},
          {name: 'searchHot', title: '搜索热度'},
          {name: 'searchTrend', title: '搜索趋势'},
          {name: 'hot', title: '热度'},
          {name: 'time', title: '时间', callback: 'date'},
        ],
        sortOrder: [
          {
            field: 'id',
            direction: 'desc'
          }
        ],
        options: null
      }
    },
    mounted () {
      this.loadAll()
    },
    methods: {
      onPaginationData (paginationData) {
        this.$refs.pagination.setPaginationData(paginationData)
        this.$refs.paginationInfo.setPaginationData(paginationData)
      },
      onChangePage (page) {
        this.page = page
        this.$refs.vuetable.changePage(page)
        this.load()
      },
      refresh: function () {
          this.$refs.vuetable.reload();
          this.load();
      },
      loadAll: function () {
        this.starId = ''
        this.loadRank();
        this.load();
      },
      loadRank: function () {
        axios.get('/episode-hot/rank?type=' + this.type).then(({data}) => {
          this.names = data
        })
      },
      load: function () {
        axios.get('/episode-hot/chart?name=' + this.starId + '&type=' + this.type + '&page=' + this.page).then(data => {
          let series = [];
          let legend = [];
          for (let item of data.data) {
            let name = item[0].name;
            series.push({
              name: name,
              type: 'line',
              data: item.map(e => [e.time, e.searchHot])
            });
            legend.push(name);
          }
          this.options =
              {
                title: {
                  text: '走势图'
                },
                legend: {
                  data: legend
                },
                tooltip: {
                  trigger: 'axis'
                },
                toolbox: {
                  feature: {
                    saveAsImage: {}
                  }
                },
                xAxis: {
                  type: 'time'
                },
                yAxis: {
                  type: 'value'
                },
                series: series
              };
        });
      },
      date: function (value) {
        let date = new Date(value);
        return date.toLocaleString();
      }
    }
  }
</script>
